<template>
  <div class="sar-page">
    <!-- 面包屑导航 -->
    <div>
        <nav class="breadcrumb-nav">
            <router-link to="/">首页</router-link>
            <span class="separator">/</span>
            <router-link to="/product">产品中心</router-link>
            <span class="separator">/</span>
            <span class="current">智慧审计与全面风险管理平台</span> 
        </nav>
    </div>

    <!-- 英雄区 -->
    <section class="sar-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1 class="sar-h1">智慧审计与全面风险管理数字化解决方案</h1>
        <p class="sar-subhead">覆盖非现场审计、经责审计、干部画像、风险矩阵、全面风险管理、企业经营画像、审计指挥舱、监督评价等八大领域，助力央企国企审计、风控、合规数字化转型。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="sar-btn sar-btn-primary" @click.prevent="openModal">预约整体方案演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="sar-btn sar-btn-outline" @click.prevent="downloadBrochure">下载产品家族手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（综合高频词） -->
      <div class="sar-keyword-cloud">
        <h2 class="sar-keyword-tag highlight">非现场审计</h2>
        <h2 class="sar-keyword-tag">经济责任审计</h2>
        <h2 class="sar-keyword-tag">干部画像</h2>
        <h2 class="sar-keyword-tag">风险矩阵</h2>
        <h2 class="sar-keyword-tag">全面风险管理</h2>
        <h2 class="sar-keyword-tag">企业经营画像</h2>
        <h2 class="sar-keyword-tag">审计指挥舱</h2>
        <h2 class="sar-keyword-tag">审计监督评价</h2>
        <h2 class="sar-keyword-tag">ERM系统</h2>
        <h2 class="sar-keyword-tag">央企审计</h2>
      </div>
    </section>

    <!-- 解决方案卡片列表（8大方向） -->
    <section class="sar-container">
      <h2><i class="fa-regular fa-star"></i> 智慧审计 八大核心方案</h2>
      <div class="container">
        <div class="sar-card-grid-2">
          <!-- 1. 非现场数字化审计作业工具 -->
          <div class="sar-solution-card">
            <div class="sar-card-header">
              <div class="sar-card-title">
                <h3 class="sar-h3">非现场数字化审计作业工具</h3>
                <span style="color: var(--sar-accent-blue);">远程审计平台</span>
              </div>
            </div>
            <div class="sar-keyword-mini">
              <span>非现场审计</span><span>远程审计</span><span>数字化审计</span><span>大数据审计</span><span>持续审计</span>
            </div>
            <p><strong>背景：</strong> 央企国企向持续审计、远程审计转型，传统模式成本高、周期长。</p>
            <p><strong>挑战：</strong> 人工抽样覆盖率低、数据分散、风险预警滞后。</p>
            <p><strong>解决方案：</strong> 统一数据中台+智能模型库+远程取数引擎+工单闭环。</p>
            <p><strong>成果：</strong> 审计覆盖率提升60%以上，周期缩短30%-50%。</p>
          </div>

          <!-- 2. 领导干部经济责任审计智能评价系统 -->
          <div class="sar-solution-card">
            <div class="sar-card-header">
              <div class="sar-card-title">
                <h3 class="sar-h3">领导干部经济责任审计智能评价</h3>
                <span style="color: var(--sar-accent-blue);">经责审计</span>
              </div>
            </div>
            <div class="sar-keyword-mini">
              <span>经济责任审计</span><span>干部画像</span><span>履职评价</span><span>央企干部考核</span>
            </div>
            <p><strong>背景：</strong> 党中央要求干部履职监督数据化、客观化。</p>
            <p><strong>挑战：</strong> 评价主观性强、缺乏量化指标、审计成果未沉淀。</p>
            <p><strong>解决方案：</strong> 履职指标体系+风险责任矩阵+大数据评分+干部画像。</p>
            <p><strong>成果：</strong> 实现干部履职量化评分，为任用考核提供数据支撑。</p>
          </div>

          <!-- 3. 干部履职画像系统 -->
          <div class="sar-solution-card">
            <div class="sar-card-header">
              <div class="sar-card-title">
                <h3 class="sar-h3">干部履职画像系统</h3>
                <span style="color: var(--sar-accent-blue);">风险画像</span>
              </div>
            </div>
            <div class="sar-keyword-mini">
              <span>干部数字画像</span><span>领导履职分析</span><span>干部风险预警</span><span>监督管理</span>
            </div>
            <p><strong>背景：</strong> 全面从严治党，干部监督向数据化管理转型。</p>
            <p><strong>解决方案：</strong> 多维指标分析（经营/合规/风险/内控）+履职能力模型+雷达图+风险预警。</p>
            <p><strong>成果：</strong> 评价更客观，支持纪检监察联动，降低管理风险。</p>
          </div>

          <!-- 4. 企业风险矩阵系统 -->
          <div class="sar-solution-card">
            <div class="sar-card-header">
              <div class="sar-card-title">
                <h3 class="sar-h3">企业风险矩阵系统</h3>
                <span style="color: var(--sar-accent-blue);">风险地图</span>
              </div>
            </div>
            <div class="sar-keyword-mini">
              <span>风险矩阵</span><span>风险评估</span><span>全面风险管理</span><span>央企风控</span>
            </div>
            <p><strong>背景：</strong> 国资委推进全面风险管理体系建设。</p>
            <p><strong>挑战：</strong> 风险识别碎片化、缺乏量化评估、责任不清。</p>
            <p><strong>解决方案：</strong> 标准化风险库+分级分类+风险矩阵模型+可视化地图+闭环整改。</p>
            <p><strong>成果：</strong> 风险透明化，处置效率提升40%。</p>
          </div>

          <!-- 5. 企业全面风险管理平台（ERM） -->
          <div class="sar-solution-card">
            <div class="sar-card-header">

              <div class="sar-card-title">
                <h3 class="sar-h3">企业全面风险管理平台</h3>
                <span style="color: var(--sar-accent-blue);">ERM系统</span>
              </div>
            </div>
            <div class="sar-keyword-mini">
              <span>全面风险管理</span><span>内控合规</span><span>风险管控数字化</span><span>国企风控</span>
            </div>
            <p><strong>解决方案：</strong> 风险识别+评估+预警+整改闭环，合规风险管理，内控评价，数据仪表盘。</p>
            <p><strong>成果：</strong> 提升合规管理能力，降低重大经营风险，实现数据可视化决策。</p>
          </div>

          <!-- 6. 企业审计经营画像系统 -->
          <div class="sar-solution-card">
            <div class="sar-card-header">
              <div class="sar-card-title">
                <h3 class="sar-h3">企业审计经营画像系统</h3>
                <span style="color: var(--sar-accent-blue);">经营画像</span>
              </div>
            </div>
            <div class="sar-keyword-mini">
              <span>企业经营分析</span><span>审计经营画像</span><span>数字画像</span><span>智能决策</span>
            </div>
            <p><strong>解决方案：</strong> 整合财务、业务、风险数据，输出经营能力评分，行业对标，趋势预测。</p>
            <p><strong>成果：</strong> 支撑集团战略决策，优化资源配置，提升经营质量。</p>
          </div>

          <!-- 7. 审计管理指挥舱（智慧审计驾驶舱） -->
          <div class="sar-solution-card">
            <div class="sar-card-header">
              <div class="sar-card-title">
                <h3 class="sar-h3">审计管理指挥舱</h3>
                <span style="color: var(--sar-accent-blue);">智慧审计驾驶舱</span>
              </div>
            </div>
            <div class="sar-keyword-mini">
              <span>审计指挥舱</span><span>审计驾驶舱</span><span>数据可视化</span><span>集团审计</span>
            </div>
            <p><strong>挑战：</strong> 审计成果分散、进度不透明、无法宏观统筹。</p>
            <p><strong>解决方案：</strong> 项目全流程可视化+区域对比分析+成果多维统计+子单位评估。</p>
            <p><strong>成果：</strong> 集团集中监控，决策效率提升，监督穿透力增强。</p>
          </div>

          <!-- 8. 审计监督评价体系 -->
          <div class="sar-solution-card">
            <div class="sar-card-header">
              <div class="sar-card-title">
                <h3 class="sar-h3">审计监督评价体系</h3>
                <span style="color: var(--sar-accent-blue);">智能模型平台</span>
              </div>
            </div>
            <div class="sar-keyword-mini">
              <span>审计监督</span><span>评价体系</span><span>智能审计模型</span><span>财务审计</span><span>内控审计</span>
            </div>
            <p><strong>背景：</strong> 国资委要求构建智能化、持续化审计监督体系。</p>
            <p><strong>解决方案：</strong> 财务审计模型+内部控制评价+绩效审计体系+风险评分模型+数据标准化。</p>
            <p><strong>成果：</strong> 评价标准统一，审计质量显著提升，支持持续非现场审计。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 总体能力定位与关键词总结 -->
    <section class="sar-container">
      <h2><i class="fa-regular fa-star"></i> 总体能力定位 </h2>
      <div class="sar-arch-card" style="background: var(--sar-primary-soft); padding: 48px; border-radius: 40px;">
        <div class="sar-keyword-cloud" style="justify-content: center; margin-top: 30px;">
          <span class="sar-keyword-tag">央企国企数字化审计</span>
          <span class="sar-keyword-tag">审计信息化建设</span>
          <span class="sar-keyword-tag">风险管理数字化转型</span>
          <span class="sar-keyword-tag">内控合规体系建设</span>
          <span class="sar-keyword-tag">干部经济责任审计</span>
          <span class="sar-keyword-tag">大数据审计模型</span>
          <span class="sar-keyword-tag">智慧审计驾驶舱</span>
          <span class="sar-keyword-tag">企业全面风险管理(ERM)</span>
          <span class="sar-keyword-tag">数据治理与审计融合</span>
          <span class="sar-keyword-tag">审计风控一体化平台</span>
        </div>
      </div>
    </section>

    <!-- 适配客户类型 -->
    <section class="sar-container">
      <h2><i class="fa-regular fa-star"></i> 适用客户群体 </h2>
      <div class="sar-client-tags">
        <span class="sar-client-tag">央企集团总部</span>
        <span class="sar-client-tag">地方国资委监管企业</span>
        <span class="sar-client-tag">金融控股集团</span>
        <span class="sar-client-tag">能源/电力/通信企业</span>
        <span class="sar-client-tag">保险行业</span>
        <span class="sar-client-tag">大型制造集团</span>
        <span class="sar-client-tag">审计部门</span>
        <span class="sar-client-tag">风控合规部门</span>
      </div>
    </section>

    <!-- 整体价值指标（估算） -->
    <section class="sar-container">
      <h2><i class="fa-regular fa-star"></i> 整体价值指标</h2>
      <div class="sar-stat-grid-4">
        <div class="sar-stat-card">
          <div class="sar-stat-number">60%+</div>
          <p>审计覆盖率提升</p>
        </div>
        <div class="sar-stat-card">
          <div class="sar-stat-number">30%-50%</div>
          <p>审计周期缩短</p>
        </div>
        <div class="sar-stat-card">
          <div class="sar-stat-number">40%</div>
          <p>风险处置效率提升</p>
        </div>
        <div class="sar-stat-card">
          <div class="sar-stat-number">100%</div>
          <p>干部量化评价</p>
        </div>
      </div>
    </section>

    <!-- 相关产品推荐 -->
    <section class="sar-container">
      <h2><i class="fa-regular fa-star"></i> 相关产品与平台</h2>
      <div class="sar-related-grid">
        <router-link to="/product/risk-compliance-platform" class="sar-related-card">
          <i class="fa-regular fa-shield-check" style="font-size: 2rem; color: #1D4E4E; margin-bottom: 12px;"></i>
          <h3 class="sar-h3">风控合规数字化平台</h3>
          <p>集合风险识别、合规管理、内控评价于一体的综合平台，实现风险全生命周期管理。</p>
        </router-link>
        <router-link to="/product/penetrating-supervision" class="sar-related-card">
          <i class="fa-regular fa-magnifying-glass-chart" style="font-size: 2rem; color: #1D4E4E; margin-bottom: 12px;"></i>
          <h3 class="sar-h3">穿透式监管平台</h3>
          <p>全链条风险穿透与责任追溯，实现监管全覆盖、问题可追溯、风险可量化。</p>
        </router-link>
        <router-link to="/product/ai-agent" class="sar-related-card">
          <h3 class="sar-h3">AI智能体平台</h3>
          <p>多智能体协同，数据分析智能体与数据治理智能体融合，实现自动分析与智能决策。</p>
        </router-link>
        <router-link to="/product/data-governance-platform" class="sar-related-card">
          <h3 class="sar-h3">智能数据管理与治理平台</h3>
          <p>企业级数据资产管理，数据标准、质量、安全一体化治理，支撑数据驱动决策。</p>
        </router-link>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="sar-container">
      <h2><i class="fa-regular fa-circle-question"></i> 常见问题</h2>
      <div class="sar-faq-list">
        <div class="sar-faq-item">
          <div class="sar-faq-question"><i class="fa-regular fa-message"></i> 这些系统能否一体化部署？</div>
          <div class="sar-faq-answer">可以。古杉数据提供审计风控一体化平台，所有模块基于统一数据中台构建，支持按需组合、分步实施。</div>
        </div>
        <div class="sar-faq-item">
          <div class="sar-faq-question"><i class="fa-regular fa-message"></i> 是否支持与现有ERP、财务系统对接？</div>
          <div class="sar-faq-answer">支持。平台提供标准化API接口，可快速对接SAP、用友、金蝶、NC等主流系统，实现数据自动同步。</div>
        </div>
        <div class="sar-faq-item">
          <div class="sar-faq-question"><i class="fa-regular fa-message"></i> 如何保障数据安全？</div>
          <div class="sar-faq-answer">支持私有化部署，符合等保2.0、国资监管要求。所有操作留痕，数据加密传输与存储。</div>
        </div>
        <div class="sar-faq-item">
          <div class="sar-faq-question"><i class="fa-regular fa-message"></i> 实施周期需要多久？</div>
          <div class="sar-faq-answer">根据模块组合和系统规模，一般3-6个月可完成试点上线。提供敏捷交付模式，快速验证价值。</div>
        </div>
      </div>
    </section>

    <!-- 最终CTA -->
    <section class="sar-container cta-section">
      <h2>预约咨询</h2>
      <div class="cta-inner">
        <h3 class="cta-heading">构建数字化审计风控与臺强审计监督评价体系</h3>
        <p class="cta-sub">当前已服务 100+ 央企国企，覆盖能源、电力、制造、金融等重点行业</p>
        <div class="cta-actions">
          <button class="cta-btn cta-btn--primary" @click="showModal = true">
            <i class="fas fa-calendar-check"></i>
            预约咨询
          </button>
          <button class="cta-btn cta-btn--outline" @click="showQrCode">
            <i class="fab fa-weixin"></i>
            扫码添加顾问
          </button>
        </div>
        <div class="cta-contact-row">
          <span><i class="fas fa-phone-alt"></i> 185-1017-6330</span>
          <span class="divider">|</span>
          <span><i class="fas fa-envelope"></i> pmo@gushandata.cn</span>
          <span class="divider">|</span>
          <span><i class="fas fa-clock"></i> 1小时内响应 · 严格保密</span>
        </div>
      </div>
    </section>

    <!-- 预约咨询弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showModal" @click.self="showModal = false">
      <div class="modal-container appointment-modal">
        <div class="modal-header">
          <div class="modal-header-icon"><i class="fas fa-calendar-check"></i></div>
          <div>
            <h3 class="modal-title">预约专家一对一咨询</h3>
            <p class="modal-subtitle">我们将在 1 小时内安排资深顾问与您联系</p>
          </div>
          <button class="modal-close-btn" @click="showModal = false"><i class="fas fa-times"></i></button>
        </div>
        <form class="appt-form" @submit.prevent="submitForm">
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input type="text" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label>联系电话 <span class="required">*</span></label>
              <input type="tel" placeholder="便于顾问联系您" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>公司名称</label>
              <input type="text" placeholder="您所在的公司" />
            </div>
            <div class="form-group">
              <label>职位</label>
              <input type="text" placeholder="您的职位/部门" />
            </div>
          </div>
          <div class="form-group">
            <label>和咨询方向</label>
            <select>
              <option value="">-- 请选择和咨询方向 --</option>
              <option>审计数字化转型规划</option>
              <option>审计监督评价体系建设</option>
              <option>风险矩阵与风控体系</option>
              <option>AI 审计应用落地</option>
              <option>审计数据集市建设</option>
              <option>其他（请备注）</option>
            </select>
          </div>
          <div class="form-group">
            <label>补充说明</label>
            <textarea rows="2" placeholder="简述您的业务场景或待解决的问题（可选）"></textarea>
          </div>
          <button type="submit" class="form-submit-btn">
            <i class="fas fa-paper-plane"></i> 提交预约
          </button>
          <p class="form-privacy"><i class="fas fa-lock"></i> 您的信息将严格保密，仅用于本次咨询联系</p>
        </form>
      </div>
    </div>
    </transition>

    <!-- 扫码添加顾问弹窗 -->
    <transition name="modal-fade">
    <div class="modal-overlay" v-if="showQrModal" @click.self="showQrModal = false">
      <div class="modal-container qr-modal">
        <div class="modal-header">
          <div class="modal-header-icon qr-header-icon"><i class="fab fa-weixin"></i></div>
          <div>
            <h3 class="modal-title">扫码添加顾问</h3>
            <p class="modal-subtitle">加微信，获取一对一专属服务</p>
          </div>
          <button class="modal-close-btn" @click="showQrModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="qr-grid">
          <div class="qr-card" v-for="(img, idx) in qrImages" :key="idx">
            <div class="qr-img-wrap">
              <img v-if="img" :src="img" :alt="'顾问二维码 ' + (idx+1)" class="qr-img" />
              <div v-else class="qr-placeholder"><i class="fab fa-weixin"></i><span>二维码占位</span></div>
            </div>
            <div class="qr-card-label">扫码添加「智能审计」专属顾问</div>
            <div class="qr-scan-hint"><i class="fas fa-qrcode"></i> 扫一扫即可添加</div>
          </div>
        </div>
        <p class="qr-footer-tip">或致电 <strong>185-1017-6330</strong> 直接预约顶层顾问服务</p>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ProductDetail_SmartAuditRisk',
  data() {
    return {
      showModal: false,
      showQrModal: false,
      qrImages: [require('@/assets/img/qr_gu.jpg'), require('@/assets/img/qr_sang.jpg')],
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitDemo() {
      alert('感谢您的预约，古杉数据专家将在24小时内与您联系。');
      this.showModal = false;
      this.form = { name: '', company: '', email: '', phone: '', message: '' };
    },
    downloadBrochure() {
      alert('产品家族手册下载中…… (实际可替换为PDF链接)');
    },
    submitForm() {
      alert('表单已提交')
      this.showModal = false
    },
    showQrCode() {
      this.showQrModal = true
    }
  }
};
</script>

<style scoped>
.sar-page {
  --sar-primary-dark: #1D4E4E;
  --sar-primary-soft: #e9f3f2;
  --sar-accent-gold: #D4AF37;
  --sar-accent-blue: #2A7DE1;
  --sar-gray-light: #f8fafc;
  --sar-gray-border: #e2e8f0;
  --sar-text-dark: #0f2a2a;
  --sar-text-regular: #2d3f4b;
  --sar-white: #ffffff;
  --sar-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  background-color: #ffffff;
  color: var(--sar-text-regular);
  font-size: 16px;
  line-height: 1.8;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

.sar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 24px;
}



section.sar-container {
  padding: 40px 12px;
}

.sar-h1, .section_title, .sar-h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color:#1F3F8F;
}

.sar-h1 {
  font-size: 42px;
  line-height: 1.2;
}

.section_title {
  font-size: 28px;
  margin-bottom: 24px;
    color: #1F3F8F;
}

.section_title i {
  color: #1F3F8F;
  margin-right: 8px;
}

.sar-h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.sar-subhead {
  font-size: 18px;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.sar-btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.sar-btn-primary {
  background-color: #1D4E4E;
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.sar-btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}

.sar-btn-outline {
  background-color: transparent;
  border: 1.5px solid #1D4E4E;
  color: #1D4E4E;
}

.sar-btn-outline:hover {
  background-color: #1D4E4E;
  color: white;
}

.sar-btn-accent {
  background-color: var(--sar-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.sar-btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 关键词标签云 */
.sar-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.sar-keyword-tag {
  background: var(--sar-white);
  color: #1D4E4E;
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.sar-keyword-tag.highlight {
  background: var(--sar-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.sar-card-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin: 40px 0;
}

.sar-solution-card {
  background: white;
  border-radius: 28px;
  padding: 32px;
  box-shadow: var(--sar-shadow);
  border: 1px solid var(--sar-gray-border);
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
}

.sar-solution-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.sar-card-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.sar-card-icon {
  width: 56px;
  height: 56px;
  background: var(--sar-primary-soft);
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: #1D4E4E;
}

.sar-card-title {
  flex: 1;
}

.sar-card-title .sar-h3 {
  margin-bottom: 4px;
}

.sar-keyword-mini {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 12px 0;
}

.sar-keyword-mini span {
  background: var(--sar-primary-soft);
  color: #1D4E4E;
  padding: 4px 10px;
  border-radius: 30px;
  font-size: 0.7rem;
  font-weight: 500;
}

.sar-stat-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.sar-stat-card {
  background: var(--sar-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.sar-stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1D4E4E;
  margin-bottom: 8px;
}

.sar-client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.sar-client-tag {
  background: white;
  border: 1px solid var(--sar-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--sar-text-dark);
}

.sar-faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.sar-faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--sar-gray-border);
}

.sar-faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--sar-text-dark);
}

.sar-faq-question i {
  color: var(--sar-accent-gold);
}

.sar-faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

.sar-cta-block {
  background: #f8fafc;
  border-radius: 56px;
  padding: 64px 56px;
  color: white;
  text-align: center;
}

.sar-cta-block .section_title {
  color: #1D4E4E;
}

.sar-cta-block .sar-btn-primary {
  background-color: white;
  color: #1D4E4E;
  margin: 0 8px;
}

.sar-cta-block .sar-btn-outline {
  border-color: white;
  color: white;
}

.sar-cta-block .sar-btn-outline:hover {
  background-color: white;
  color: #1D4E4E;
}

.sar-arch-card {
  box-shadow: var(--sar-shadow);
}

/* 相关产品推荐 */
.sar-related-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 10px;
}

.sar-related-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--sar-shadow);
  border: 1px solid var(--sar-gray-border);
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: var(--sar-text-regular);
}

.sar-related-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.sar-related-card .sar-h3 {
  color: #1D4E4E;
}

/* 模态框 */
.sar-modal {
  display: flex;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  align-items: center;
  justify-content: center;
}

.sar-modal-content {
  background: white;
  border-radius: 40px;
  max-width: 500px;
  width: 90%;
  padding: 40px;
  box-shadow: 0 30px 60px rgba(0,0,0,0.3);
  position: relative;
}

.sar-close-modal {
  position: absolute;
  top: 20px;
  right: 24px;
  font-size: 28px;
  cursor: pointer;
  color: #999;
}

.sar-modal .sar-h3 {
  margin-bottom: 24px;
}

.sar-form-group {
  margin-bottom: 20px;
}

.sar-form-group input,
.sar-form-group textarea {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid var(--sar-gray-border);
  border-radius: 30px;
  font-size: 1rem;
}

.sar-modal .sar-btn {
  width: 100%;
  margin-top: 10px;
}

.sar-footer {
  text-align: center;
  padding: 40px 0;
  color: #7f8d9c;
  border-top: 1px solid var(--sar-gray-border);
  margin-top: 40px;
}


/* 面包屑导航 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  font-size: 14px;
  color: #5f6a7d;
}

.breadcrumb-nav a {
  color: #1F3F8F;
  text-decoration: none;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--sar-accent-blue);
  font-weight: 600;
}

@media (max-width: 1000px) {
  .sar-card-grid-2 {
    grid-template-columns: 1fr;
  }
  .sar-stat-grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
  .sar-related-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .sar-stat-grid-4 {
    grid-template-columns: 1fr;
  }  .sar-related-grid {
    grid-template-columns: 1fr;
  }  .sar-h1 {
    font-size: 32px;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

h2 {
  font-size: 28px;
  font-weight: 700;
  color: var(--deep-indigo);
  margin-bottom: 40px;
  letter-spacing: -0.01em;
  position: relative;
  display: inline-block;
}
h2:after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 60px;
  height: 3px;
  background-color: var(--primary-blue);
  border-radius: 4px;
}




/* ============ 底部预约咨询模块 ============ */
.cta-section {
  margin-bottom: 60px;
}
.cta-inner {
  background: linear-gradient(135deg, #EAF0FB 0%, #F6F8FC 100%);
  border: 1px solid #D6E2F5;
  border-radius: 24px;
  padding: 48px 40px;
  text-align: center;
  color: #0E1F52;
  box-shadow: 0 8px 32px rgba(14,31,82,0.08);
}
.cta-heading {
  font-size: 24px;
  font-weight: 700;
  color: #0E1F52;
  margin-bottom: 10px;
  line-height: 1.45;
}
.cta-sub {
  font-size: 14px;
  color: #5A5E66;
  margin-bottom: 32px;
}
.cta-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: 50px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s;
  text-decoration: none;
}
.cta-btn--primary {
  background: #1F3F8F;
  color: #fff;
}
.cta-btn--primary:hover {
  background: #0E1F52;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(14,31,82,0.22);
}
.cta-btn--outline {
  background: #fff;
  color: #1F3F8F;
  border: 2px solid #1F3F8F;
}
.cta-btn--outline:hover {
  background: #EAF0FB;
  border-color: #0E1F52;
  color: #0E1F52;
  transform: translateY(-2px);
}
.cta-contact-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #7B8794;
  font-size: 12px;
}
.cta-contact-row i { margin-right: 4px; color: #1F3F8F; }
.cta-contact-row .divider { color: #CBD3E0; }

/* ============ 弹窗通用 ============ */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(11,26,51,0.65);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal-container {
  background: #fff;
  border-radius: 16px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(14,31,82,0.22);
  overflow: hidden;
}

/* 弹窗头部 */
.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 18px 22px 16px;
  border-bottom: 1px solid #EEF1F8;
  position: relative;
}
.modal-header-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #EAF0FB;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.qr-header-icon {
  background: #e8f5e9;
  color: #07c160;
}
.modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0 0 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: #7b8794;
  margin: 0;
}
.modal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: #F4F6FB;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6a7d;
  font-size: 14px;
  transition: background 0.2s;
}
.modal-close-btn:hover { background: #e2e8f4; }

/* 预约表单 */
.appt-form {
  padding: 16px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 480px) {
  .form-row { grid-template-columns: 1fr; }
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #2B2F3A;
}
.form-group .required { color: #e55353; }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1.5px solid #E0E6F0;
  border-radius: 8px;
  font-size: 13px;
  color: #2B2F3A;
  background: #FAFBFD;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
  resize: vertical;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #1F3F8F;
  box-shadow: 0 0 0 3px rgba(31,63,143,0.1);
  background: #fff;
}
.form-submit-btn {
  width: 100%;
  padding: 11px;
  background: #1F3F8F;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s, transform 0.2s;
  margin-top: 4px;
}
.form-submit-btn:hover {
  background: #0e3170;
  transform: translateY(-1px);
}
.form-privacy {
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  margin: -4px 0 0;
}
.form-privacy i { margin-right: 4px; }

/* 二维码弹窗 */
.qr-modal { max-width: 560px; }
.qr-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 24px 28px;
}
.qr-card {
  flex: 1;
  min-width: 180px;
  max-width: 220px;
  background: #F8FAFF;
  border-radius: 16px;
  border: 1px solid #E0E8F8;
  padding: 20px 16px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.qr-img-wrap {
  width: 160px;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #dde5f5;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 13px;
}
.qr-placeholder i { font-size: 36px; color: #07c160; opacity: 0.5; }
.qr-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #0E1F52;
  line-height: 1.4;
}
.qr-scan-hint {
  font-size: 12px;
  color: #9ca3af;
}
.qr-scan-hint i { margin-right: 4px; }
.qr-footer-tip {
  text-align: center;
  font-size: 13px;
  color: #7b8794;
  padding: 0 28px 22px;
  margin: 0;
}
.qr-footer-tip strong { color: #0E1F52; }

/* 弹窗入场动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}
.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.25s ease, opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to { opacity: 0; }
.modal-fade-enter-from .modal-container,
.modal-fade-leave-to .modal-container {
  transform: translateY(24px) scale(0.97);
  opacity: 0;
}

</style>
